import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Maximize2, X } from "lucide-react";
import { toast } from "sonner";
import { api, fmtErr } from "../../api";
import { Thread } from "./Thread";

const Ctx = createContext(null);

// MESSAGE PANEL — a slide-over thread you can open from anywhere (Team map, Job Room, Project Room) without leaving the page.
export function MessagePanelProvider({ children }) {
  const [cid, setCid] = useState(null);
  const nav = useNavigate();
  const open = useCallback(async (target) => {
    try {
      if (target.cid) return setCid(target.cid);
      const r = target.kind === "direct" ? await api.post("/messages/direct", { user_id: target.user_id }) : await api.get(`/messages/${target.kind}/${target.kind === "job" ? target.job_id : target.project_id}`);
      setCid(r.data.id);
    } catch (e) { toast.error(fmtErr(e)); }
  }, []);
  const close = useCallback(() => setCid(null), []);
  useEffect(() => { if (!cid) return; const h = (e) => e.key === "Escape" && close(); window.addEventListener("keydown", h); return () => window.removeEventListener("keydown", h); }, [cid, close]);
  return (
    <Ctx.Provider value={{ open, close }}>
      {children}
      {cid && (
        <div className="fixed inset-0 z-[58] flex justify-end bg-zinc-950/40 backdrop-blur-[1px]" onClick={close} data-testid="message-panel-backdrop">
          <div className="relative flex h-full w-full max-w-[520px] flex-col border-l border-line bg-surface shadow-2xl animate-in" onClick={(e) => e.stopPropagation()} data-testid="message-panel">
            <div className="absolute right-2 top-2 z-10 flex gap-1">
              <button className="btn-icon" title="Open in Messages" onClick={() => { close(); nav(`/messages?c=${cid}`); }} data-testid="message-panel-expand"><Maximize2 size={14} /></button>
              <button className="btn-icon" onClick={close} data-testid="message-panel-close"><X size={15} /></button>
            </div>
            <div className="min-h-0 flex-1 pr-0 [&>div>div:first-child]:pr-20"><Thread cid={cid} compact /></div>
          </div>
        </div>
      )}
    </Ctx.Provider>
  );
}

export const useMessagePanel = () => useContext(Ctx) || { open: () => {}, close: () => {} };
